// ============================================================
// ADMIN PANEL CONSTANTS — TAKEAWAY / PICKUP PLATFORM
// ============================================================

export const ADMIN_CREDENTIALS = {
  username: 'biryani_admin',
  password: 'biryani_admin_1801',
};

export const AUTH_TOKEN_KEY = 'biryani_admin_token';
export const AUTH_USER_KEY = 'biryani_admin_user';

// Backend API base URL — points to the Flask backend
// Use REACT_APP_API_BASE_URL if available, fallback to REACT_APP_API_URL, then localhost
const baseUrl = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API_BASE_URL = baseUrl.endsWith('/api') ? baseUrl : `${baseUrl}/api`;

export const ROLES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  FINANCE_MANAGER: 'Finance Manager',
  RESTAURANT_MANAGER: 'Restaurant Manager',
  SUPPORT_EXECUTIVE: 'Support Executive',
  OPERATIONS_MANAGER: 'Operations Manager',
};

export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
  SUSPENDED: 'suspended',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  OPEN: 'open',
  CLOSED: 'closed',
  RESOLVED: 'resolved',
};

// ── Takeaway-Only Order Statuses ─────────────────────────────
export const ORDER_STATUS = {
  NEW:              'new',              // Order placed, awaiting acceptance
  PENDING:          'new',             // alias
  ACCEPTED:         'accepted',         // Restaurant accepted
  PREPARING:        'preparing',        // Kitchen is preparing
  READY_FOR_PICKUP: 'ready',            // Ready — customer notified
  PICKED_UP:        'completed',        // Customer picked up
  CANCELLED:        'cancelled',        // Cancelled before prep
  REJECTED:         'rejected',         // Rejected by restaurant
};

export const ORDER_STATUS_LABELS = {
  new:       'New',
  pending:   'Pending',
  accepted:  'Accepted',
  preparing: 'Preparing',
  ready:     'Ready for Pickup',
  completed: 'Picked Up',
  cancelled: 'Cancelled',
  rejected:  'Rejected',
};

export const ORDER_STATUS_COLORS = {
  new:       '#F59E0B',
  pending:   '#F59E0B',
  accepted:  '#3B82F6',
  preparing: '#8B5CF6',
  ready:     '#10B981',
  completed: '#6B7280',
  cancelled: '#EF4444',
  rejected:  '#DC2626',
};

export const PAYMENT_STATUS = {
  PENDING:  'pending',
  PAID:     'paid',
  REFUNDED: 'refunded',
  FAILED:   'failed',
};

// ── Navigation — Simplified Sidebar ──────────────────────────
export const NAV_ITEMS = [
  // Main
  { id: 'dashboard',    label: 'Dashboard',    icon: 'LayoutDashboard', path: '/admin/dashboard',    group: 'Main' },
  { id: 'restaurants',  label: 'Restaurants',  icon: 'UtensilsCrossed', path: '/admin/restaurants',  group: 'Main' },
  { id: 'customers',    label: 'Customers',    icon: 'UserCheck',       path: '/admin/customers',    group: 'Main' },
  { id: 'orders',       label: 'Orders',       icon: 'ShoppingBag',     path: '/admin/orders',       group: 'Main' },
  { id: 'finance',      label: 'Finance',      icon: 'DollarSign',      path: '/admin/finance',      group: 'Main' },
  // Admin
  { id: 'users',        label: 'Admin Users',  icon: 'Users',           path: '/admin/users',        group: 'Admin' },
  { id: 'support',      label: 'Support',      icon: 'Headphones',      path: '/admin/support',      group: 'Admin' },
  { id: 'roles',        label: 'Roles',        icon: 'Lock',            path: '/admin/roles',        group: 'Admin' },
  { id: 'settings',     label: 'Settings',     icon: 'Settings',        path: '/admin/settings',     group: 'Admin' },
  { id: 'profile',      label: 'My Profile',   icon: 'UserCircle',      path: '/admin/profile',      group: 'Admin' },
];

export const NAV_GROUPS = ['Main', 'Admin'];

// ── Role-Based Permissions ────────────────────────────────────
export const ROLE_PERMISSIONS = {
  super_admin: null,
  admin: [
    'dashboard', 'restaurants', 'customers', 'orders',
    'finance', 'users', 'support', 'settings', 'profile',
  ],
  finance_manager: [
    'dashboard', 'finance', 'restaurants', 'profile',
  ],
  restaurant_manager: [
    'dashboard', 'restaurants', 'customers', 'orders', 'profile',
  ],
  support_executive: [
    'dashboard', 'support', 'customers', 'profile',
  ],
  operations_manager: [
    'dashboard', 'restaurants', 'customers', 'orders', 'profile',
  ],
};

// Returns allowed nav item ids for a given role. null means all.
export const getAllowedNavIds = (adminRole) => {
  if (!adminRole) return ROLE_PERMISSIONS['admin'];
  return ROLE_PERMISSIONS[adminRole] ?? ROLE_PERMISSIONS['admin'];
};


export const ITEMS_PER_PAGE = 10;

export const COLORS = {
  primary:   '#E85D04',
  secondary: '#F48C06',
  success:   '#10B981',
  danger:    '#EF4444',
  warning:   '#F59E0B',
  info:      '#3B82F6',
  dark:      '#1F2937',
  light:     '#F9FAFB',
};
